// Pretty much what it says on the tin. Helper function to capitalize a string. Returns an empty string if the input is not a string.
export const capitalize = (str) => {
  if (typeof str !== 'string') {
    // Return an empty string if the input is not a string
    return '';
  }

  return str
    .split(' ')
    .map((word) =>
      word
        .split('-')
        .map(
          (part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
        )
        .join('-')
    )
    .join(' ');
};

// Helper to add a class to an element by ID. Primarily used for adding a (view-based) custom class to the #openWidget element so it can be targeted externally.
export const addClassById = (id, className) => {
  const element = document.getElementById(id);
  if (element) {
    element.classList.add(className);
  }
};

// helper to remove a class from an element by ID. Used to clean up classes added with addClassById.
export const removeClassById = (id, className) => {
  const element = document.getElementById(id);
  if (element) {
    element.classList.remove(className);
  }
};
